var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('blue-title',[_vm._v("账号信息")]),_c('Account'),_c('blue-title',[_vm._v("权限信息")]),_c('Limit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }